import { handleActions } from 'redux-actions';

import {
  loadingUserDevices,
  successGetUserDevices,
  failureGetUserDevices,
  removingUserDevice,
  successRemoveUserDevice,
  failureRemoveUserDevice,
  removingAllUserDevices,
  successRemoveAllUserDevices,
  failureRemoveAllUserDevices,
  resetDevices,
} from '@app/actions/deviceActions';

const initialState = {
  isDevicesLoading: false,
  isDeviceRemoving: false,
  isAllDevicesRemoving: false,
  idRemovingDevice: '',
  devices: [],
  error: null,
};

export default handleActions({
  [loadingUserDevices]: state => ({
    ...state,
    isDevicesLoading: true,
  }),
  [successGetUserDevices]: (state, { payload }) => ({
    ...state,
    isDevicesLoading: false,
    devices: payload,
    error: null,
  }),
  [failureGetUserDevices]: (state, { payload }) => ({
    ...state,
    isDevicesLoading: false,
    devices: [],
    error: payload,
  }),
  [removingUserDevice]: (state, { payload }) => ({
    ...state,
    isDeviceRemoving: true,
    idRemovingDevice: payload,
  }),
  [successRemoveUserDevice]: state => ({
    ...state,
    isDeviceRemoving: false,
    idRemovingDevice: '',
  }),
  [failureRemoveUserDevice]: (state, { payload }) => ({
    ...state,
    isDeviceRemoving: false,
    idRemovingDevice: '',
    error: payload,
  }),
  [removingAllUserDevices]: state => ({
    ...state,
    isAllDevicesRemoving: true,
  }),
  [successRemoveAllUserDevices]: state => ({
    ...state,
    isAllDevicesRemoving: false,
  }),
  [failureRemoveAllUserDevices]: (state, { payload }) => ({
    ...state,
    isAllDevicesRemoving: false,
    error: payload,
  }),
  [resetDevices]: () => ({
    ...initialState,
  }),
}, initialState);
